import { render } from "./get-user-debit.vue?vue&type=template&id=b2612170&scoped=true"
import script from "./get-user-debit.vue?vue&type=script&lang=js"
export * from "./get-user-debit.vue?vue&type=script&lang=js"

import "./get-user-debit.vue?vue&type=style&index=0&id=b2612170&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2612170"]])

export default __exports__